export default "__VITE_ASSET__q8t7Pqy6__"